// extracted by mini-css-extract-plugin
export default {"container":"Vo-z","ratingLayout":"Wo-z","ratingLabel":"Xo-z","nonInteractiveRatingLabel":"Yo-z"};